import { sva } from "@stubhub/broadway-foundation/css";

const mobileBannerCardGlassBackgroundSlots = ["headerWrapper", "container", "image", "imageOverlay"] as const;

export const mobileBannerCardGlassBackgroundRecipe = sva({
  slots: mobileBannerCardGlassBackgroundSlots,
  className: "mobileBannerCardGlassBackground",
  base: {
    headerWrapper: {
      color: "text.onFill",
      display: "flex",
      position: "relative",
      zIndex: "[1]",
      rowGap: "primitives.200",
      columnGap: "primitives.200",
      paddingBlock: "primitives.150",
      paddingInline: "primitives.150",
      width: "full",
    },
    container: {
      display: "flex",
      width: "full",
      height: "full",
      insetBlockStart: "primitives.0",
      insetInlineStart: "primitives.0",
      overflowX: "hidden",
      overflowY: "hidden",
      position: "absolute",
      zIndex: "[-1]",
      borderStartRadius: "primitives.150",
      borderEndRadius: "primitives.150",
    },
    image: {
      width: "full",
      height: "full",
      objectFit: "cover",
      filter: "[blur(20px)]",
      transform: "scale(1.1)",
    },
    imageOverlay: {
      width: "full",
      height: "full",
      position: "absolute",
      zIndex: "[1]",
      backgroundImage: "linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 1) 100%)",
    },
  },
  variants: {
    bottomRadius: {
      hidden: {
        container: {
          borderEndRadius: "primitives.0",
        },
      },
      visible: {},
    },
  },
  defaultVariants: {
    bottomRadius: "visible",
  },
});
